<script>
import router from "@/router";
import simplebar from "simplebar-vue";
import { layoutComputed, routeAndMenuComputed } from "@/state/helpers";

import NavBar from "@/components/nav-bar";
import Menu from "@/components/menu.vue";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
import PageHeader from "@/components/page-header.vue";
localStorage.setItem("hoverd", false);

/**
 * Vertical layout
 */
export default {
  components: {
    NavBar,
    RightBar,
    Footer,
    Menu,
    simplebar,
    PageHeader,
  },
  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },

    menus(newValue) {
      if (newValue) {
        this.menuItems = JSON.parse(newValue);
        this.breadCrumpForRouteChanges();
      }
    },
  },
  data() {
    return {
      isMenuCondensed: false,
      title: "",
      pageTitle: "",
      menuItems: [],
      developmentWarnShow: false,
    };
  },
  computed: {
    ...layoutComputed,
    ...routeAndMenuComputed,
  },
  async created() {
    if (process.env.VUE_APP_FRONTEND_URL !== "https://unacs.atilim.edu.tr")
      this.developmentWarnShow = true;
    if (this.menus.length > 0) this.menuItems = JSON.parse(this.menus);

    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    onRoutechange(ele) {
      this.title = ele.meta.title;
      this.pageTitle = ele.meta.breadcrumbText;
      this.hideMenu();
      this.breadCrumpForRouteChanges();
    },
    breadCrumpForRouteChanges() {
      let aranacakSayfa = this.$route.name;
      let breadcrumbItem;
      breadcrumbItem = this.flattenForBreadcrumb(aranacakSayfa, this.menuItems);

      if (breadcrumbItem !== undefined) {
        this.onBreadCrumpChange(
          breadcrumbItem[breadcrumbItem.length - 1].breadcrumbText,
          breadcrumbItem[breadcrumbItem.length - 1].title
        );
      }
    },
    onBreadCrumpChange(breadcrumb, title) {
      this.title = title;
      this.pageTitle = breadcrumb;
    },

    flattenForBreadcrumb(aranacakSayfa, array) {
      if (aranacakSayfa !== undefined) {
        for (let a of array) {
          if (a.route === aranacakSayfa) {
            return [a];
          }
          if (Array.isArray(a.children)) {
            const breadcrumbItem = this.flattenForBreadcrumb(
              aranacakSayfa,
              a.children
            );
            if (breadcrumbItem) {
              return [a, ...breadcrumbItem];
            }
          }
        }
      }
      return undefined;
    },
    updateSidebarSize() {
      let sidebarSize = "";
      // Check window.screen.width and update the data-sidebar-size attribute
      if (window.innerWidth < 1025) {
        this.$store.dispatch("layout/changeSidebarSize", { sidebarSize: "sm" });
        sidebarSize = "sm";
      } else {
        this.$store.dispatch("layout/changeSidebarSize", { sidebarSize: "lg" }); // Reset sidebarSize if screen width is >= 1025
        sidebarSize = "lg";
      }
      // Update the data-sidebar-size attribute of document.documentElement
      document.documentElement.setAttribute("data-sidebar-size", sidebarSize);
    },

    initActiveMenu() {
      if (
        document.documentElement.getAttribute("data-sidebar-size") ===
        "sm-hover"
      ) {
        localStorage.setItem("hoverd", true);
        document.documentElement.setAttribute(
          "data-sidebar-size",
          "sm-hover-active"
        );
      } else if (
        document.documentElement.getAttribute("data-sidebar-size") ===
        "sm-hover-active"
      ) {
        localStorage.setItem("hoverd", false);
        document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
      } else {
        document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
      }
    },
    hideMenu() {
      document.body.classList.remove("vertical-sidebar-enable");
    },
    async refreshTokenAndReload() {
      if (!localStorage.getItem("token")) {
        await this.$router.push({ path: "/" });
        return;
      }

      const refreshed = await this.$store.dispatch("tokenRefresh/doRefresh");
      if (refreshed) {
        window.location.reload();
        return;
      }

      await this.$router.push({ path: "/" });
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");
      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (localStorage.getItem("hoverd") == "true") {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    }

    document.getElementById("overlay").addEventListener("click", () => {
      document.body.classList.remove("vertical-sidebar-enable");
    });
    if (window.screen.width < 1025) {
      document.documentElement.setAttribute("data-sidebar-size", "sm");
    }

    window.addEventListener("resize", () => {
      document.body.classList.remove("vertical-sidebar-enable");
      document.querySelector(".hamburger-icon").classList.add("open");
      this.updateSidebarSize();
    });
  },
  unmounted() {
    window.removeEventListener("resize", this.updateSidebarSize);
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar />
    <div>
      <!-- ========== Left Sidebar Start ========== -->
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- Dark Logo-->
          <router-link to="/" class="logo logo-dark" @click.prevent="refreshTokenAndReload">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt="" height="17" />
            </span>
              <h5 class="text-danger ml-1" v-if="developmentWarnShow === true">
                {{ $t("DevelopmentEnvWarnText") }}
              </h5>
          </router-link>
          <!-- Light Logo-->
          <router-link to="/" class="logo logo-light" @click.prevent="refreshTokenAndReload">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt="" height="17" />
            </span>
              <h5 class="text-danger ml-1" v-if="developmentWarnShow === true">
                {{ $t("DevelopmentEnvWarnText") }}
              </h5>
          </router-link>
          <BButton
            size="sm"
            class="p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
            @click="initActiveMenu"
          >
            <i class="ri-record-circle-line"></i>
          </BButton>
        </div>

        <simplebar id="scrollbar" class="h-100" ref="scrollbar">
          <Menu :menuItems="menuItems"  :isParent= true></Menu>
        </simplebar>
        <div class="sidebar-background"></div>
      </div>
      <!-- Left Sidebar End -->
      <!-- Vertical Overlay-->
      <div class="vertical-overlay" id="overlay"></div>
    </div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content">
      <div class="page-content">
        <!-- Start Content-->

        <BContainer fluid>
          <PageHeader :title="title" :pageTitle="pageTitle"></PageHeader>
          <slot />
        </BContainer>
      </div>
      <Footer />
    </div>
    <RightBar />
  </div>
</template>
